import { Link } from "react-router-dom"
import { Helmet, HelmetProvider } from "react-helmet-async"

const NotFound = () => {
    return (
        <div className="content-wrapper">
            <HelmetProvider>
                <Helmet>
                    <title>404 - Página no encontrada</title>
                    <meta name="robots" content="noindex" />
                </Helmet>
            </HelmetProvider>

            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0 text-danger">404 - Página no encontrada</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                                <li className="breadcrumb-item active">404</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <section className="content">
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-md-6 text-center">
                            <div className="error-page">
                                <h2 className="headline text-warning">404</h2>
                                <div className="error-content mt-3">
                                    <h3><i className="fas fa-exclamation-triangle text-warning"></i> ¡Ups! Página no encontrada.</h3>
                                    <p>
                                        No pudimos encontrar la página que estabas buscando.
                                        Mientras tanto, puedes <Link to="/dashboard">volver al Dashboard</Link>.
                                    </p>
                                    <Link to="/dashboard" className="btn btn-primary mt-3">
                                        <i className="fas fa-home"></i> Ir al inicio
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default NotFound
